let audioCtx: AudioContext | null = null;
let audioUnlocked = false;

function getCtx(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  if (!audioCtx) {
    try {
      audioCtx = new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)();
    } catch {
      return null;
    }
  }
  if (audioCtx.state === 'suspended') {
    audioCtx.resume().catch(() => {});
  }
  return audioCtx;
}

// Unlock audio on first user interaction (browsers require this)
if (typeof window !== 'undefined') {
  const unlock = () => {
    const ctx = getCtx();
    if (ctx && ctx.state === 'running') audioUnlocked = true;
  };
  window.addEventListener('click', unlock, { once: false });
  window.addEventListener('keydown', unlock, { once: false });
  window.addEventListener('touchstart', unlock, { once: false });
}

function playTone(
  ctx: AudioContext,
  freq: number,
  start: number,
  duration: number,
  type: OscillatorType = 'sine',
  volume = 0.2,
) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, start);
  gain.gain.linearRampToValueAtTime(volume, start + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.001, start + duration);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(start);
  osc.stop(start + duration);
}

export function playSuccess() {
  const ctx = getCtx();
  if (!ctx) return;
  const t = ctx.currentTime;
  playTone(ctx, 523.25, t, 0.4, 'sine', 0.2);
  playTone(ctx, 659.25, t + 0.08, 0.4, 'sine', 0.2);
  playTone(ctx, 783.99, t + 0.16, 0.5, 'sine', 0.2);
}

export function playError() {
  const ctx = getCtx();
  if (!ctx) return;
  const t = ctx.currentTime;
  playTone(ctx, 220, t, 0.3, 'sawtooth', 0.15);
  playTone(ctx, 200, t + 0.15, 0.35, 'sawtooth', 0.15);
}

export function playBeep() {
  const ctx = getCtx();
  if (!ctx) return;
  const t = ctx.currentTime;
  playTone(ctx, 880, t, 0.15, 'square', 0.1);
  playTone(ctx, 1100, t + 0.1, 0.15, 'square', 0.1);
}

export function playNotification() {
  const ctx = getCtx();
  if (!ctx) return;
  const t = ctx.currentTime;
  playTone(ctx, 523.25, t, 0.25, 'sine', 0.3);
  playTone(ctx, 659.25, t + 0.12, 0.25, 'sine', 0.3);
  playTone(ctx, 783.99, t + 0.24, 0.25, 'sine', 0.3);
  playTone(ctx, 1046.50, t + 0.36, 0.4, 'sine', 0.3);
}

export function playWarning() {
  const ctx = getCtx();
  if (!ctx) return;
  const t = ctx.currentTime;
  playTone(ctx, 440, t, 0.2, 'triangle', 0.18);
  playTone(ctx, 440, t + 0.25, 0.2, 'triangle', 0.18);
}
